import {Injectable} from '@angular/core';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ProcessingDialogComponent} from "./processing-dialog.component";

@Injectable({
  providedIn: 'root'
})
export class ProcessingDialogService {
  private dialogRef: MatDialogRef<any> | null = null;

  constructor(private dialog: MatDialog) {
  }

  public open(): void {
    this.dialogRef = this.dialog.open(ProcessingDialogComponent, {
      disableClose: true,
      width: '600px'
    });
  }

  public close(): void {
    this.dialogRef?.close();
  }

  public isOpen(): boolean {
    return this.dialogRef !== null;
  }
}
